import { Plan } from "@domains/plan";

export type PlansState = {
    plans: Plan[];
};

export const INITIAL_STATE: PlansState = {
    plans: [],
};
